<template>
  <div>
    <a-modal
      v-model="visible"
      :title="modalTit"
      on-ok="handleOk"
      width="700px"
      :mask-closable="false"
      @cancel="handleCancel"
    >
      <a-form :form="form">
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          :label="groupTit"
        >
          <a-input
            v-decorator="['groupname',{rules: [{ required: true, message: groupnamePlace,validator: checkGroupName}]}]"
            maxlength="15"
          >
            <span
              slot="addonAfter"
              style="color:#C0C4CC;"
            >{{ inputLength }}/15</span>
          </a-input>
        </a-form-item>
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          :label="groupMemberTit"
        >
          <a-select
            v-decorator="['groupMember',{rules: [{ required: false, message: groupMemberPlace }]}]"
            mode="multiple"
            style="width: 100%"
          >
            <a-select-option
              v-for="item in addGroupList"
              :key="item.userid+item.addtime"
              :value="item.userid"
            >
              {{ item.truename }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form> <template slot="footer">
        <a-button
          key="back"
          @click="handleCancel"
        >
          {{ $t('message["896"]') }}
        </a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="addGroupLoading"
          @click="handleOk"
        >
          {{ $t('message["915"]') }}
        </a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex'

const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 18 }
}
export default {
  data () {
    return {
      inputLength: 0,
      visible: false,
      formItemLayout,
      form: this.$form.createForm(this)
    }
  },
  computed: {
    ...mapState('team/manage', ['selectTreenDataId']),
    ...mapState('team/group', ['addGroupVisible', 'addGroupLoading', 'addGroupList']),
    groupnamePlace () {
      return this.$t('message["849"]')
    },
    groupMemberPlace () {
      return this.$t('message["886"]')
    },
    modalTit () {
      return this.$t('message["1197"]')
    },
    groupMemberTit () {
      return this.$t('message["1333"]')
    },
    groupTit () {
      return this.$t('message["1335"]')
    }
  },
  watch: {
    addGroupVisible (val) {
      this.visible = val
    }
  },
  mounted () {
    if (this.addGroupVisible) {
      this.setAddGroupVisible(false)
    }
  },
  methods: {
    ...mapMutations('team/group', ['setAddGroupVisible', 'setAddGroupLoading']),
    ...mapActions('team/group', ['fetchGetEnableMembers', 'fetchSaveGroup']),
    // 添加小组--自定义校验小组名称方法
    checkGroupName (rule, value, callback) {
      if (value === '') {
        this.inputLength = 0
        callback(new Error(this.$t('message["849"]')))
        return false
      }
      this.inputLength = value.length
      if (this.inputLength === 0) {
        callback(new Error(this.$t('message["849"]')))
        return false
      }
      callback()
    },
    // 添加小组---保存操作
    handleOk (e) {
      if (!this.form.getFieldValue('groupname')) {
        this.form.setFieldsValue({ 'groupname': '' })
      }
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          if (!values.groupMember) {
            values.groupMember = []
          }
          this.setAddGroupLoading(true)
          this.fetchSaveGroup(values)
          this.inputLength = 0
          this.form.resetFields('groupname')
          this.form.resetFields('groupMember')
        }
      })
    },
    // 添加小组---取消操作
    handleCancel (e) {
      this.form.resetFields('groupname')
      this.form.resetFields('groupMember')
      this.inputLength = 0
      this.setAddGroupLoading(false)
      this.setAddGroupVisible(false)
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-title-section {
  margin-bottom: 25px;
  font-size: 20px;
  span {
    margin-left: 10px;
  }
}
.input-main {
  width: 100%;
}
.s-info {
  color: #c0c4cc;
  margin-left: 5px;
}
</style>
